import './style.scss';

// Block stores
import './blocks/Layout/MediaScroll/front.js';

// Block enhancements
import './blocks/Enhancements/EmbedPoster/front.js';

let domReady = window?.wp?.domReady;

// Fallback if wp.domReady is not available
if (!domReady) {
  console.warn('wp.domReady not found, using fallback.');
  domReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };
}

// Utility: Active State Toggle
function initLanguageSwitcher() {
  const btn = document.querySelector('.js-language-switcher-btn');
  const container = document.querySelector('.gtranslate_wrapper');
  if (btn && container) {
    btn.addEventListener('click', () => {
      container.classList.toggle('is-open');
    });

    document.addEventListener('click', (event) => {
      if (!btn.contains(event.target) && !container.contains(event.target)) {
        container.classList.remove('is-open');
      }
    });
  }
}

// Sticky ToC Blade
function initStickyTOC() {
  const toc = document.querySelector('.post-toc-accordion');
  const parent = document.querySelector('.single-post-body__content');

  if (toc && parent) {
    const placeholder = document.createElement('div');
    placeholder.style.height = toc.offsetHeight + 'px';
    placeholder.style.display = 'none';
    toc.parentNode.insertBefore(placeholder, toc);

    function updateWidth() {
      if (toc.classList.contains('is-fixed') || toc.classList.contains('is-absolute')) {
        toc.style.width = parent.offsetWidth + 'px';
      } else {
        toc.style.width = 'auto';
      }
    }

    window.addEventListener('scroll', () => {
      const parentRect = parent.getBoundingClientRect();
      const tocHeight = toc.offsetHeight;
      const offsetTop = 20;

      if (parentRect.top < offsetTop && (parentRect.bottom - tocHeight) > offsetTop) {
        toc.classList.add('is-fixed');
        toc.classList.remove('is-absolute', 'is-static');
        placeholder.style.display = 'block';
      } else if ((parentRect.bottom - tocHeight) <= offsetTop) {
        toc.classList.add('is-absolute');
        toc.classList.remove('is-fixed', 'is-static');
        placeholder.style.display = 'block';
      } else {
        toc.classList.add('is-static');
        toc.classList.remove('is-fixed', 'is-absolute');
        placeholder.style.display = 'none';
      }

      updateWidth();
    });

    window.addEventListener('resize', updateWidth);

    // Initial width set
    updateWidth();
  }
}

// Device Touch Type
function conditionallyAddTouchClass() {
  // Check if device is touch screen or not
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  if (isTouchDevice) {
    document.body.classList.add('touch');
  } else {
    document.body.classList.add('no-touch');
  }
}

domReady(() => {
  initLanguageSwitcher();
  initStickyTOC();
  conditionallyAddTouchClass();
});